import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as HomeActions from 'src/app/store/home/home.actions';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { TasksPollingService } from 'src/app/services/task-polling.service';
import { ConfirmationService } from 'primeng/api';
import { selectEditSystem } from 'src/app/store/device-vct/device-vct.selector';
import { filter, Observable, Subscription } from 'rxjs';
import { selectIsImpersMode } from 'src/app/store/user/user.selector';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { Site } from 'src/app/model/site';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { AddGatewayDialogComponent } from 'src/app/modules/shared/components/add-gateway-dialog/add-gateway-dialog.component';
import { CommonCustomConfirmDialogComponent } from 'src/app/modules/shared/components/common-custom-confirm-dialog/common-custom-confirm.dialog.component';

@Component({
	selector: 'app-device-category-tab-group',
	templateUrl: './device-category-tab-group.component.html',
	providers: [ConfirmationService, DialogService],
	styles: `
		:host ::ng-deep .transparent-tabView .p-tabview-panels {
			background: transparent !important;
			padding-left: 0px;
			padding-right: 0px;
		}
		:host ::ng-deep .p-accordion-header-link {
			// background-color: #FAFBFF !important;
			border: 1px solid #D5D5D5 !important;
			margin-bottom: 2px;
		}
		:host ::ng-deep .p-accordion-header-link:hover {
			background-color: var(--surface-500) !important;
		}
	`
})

export class DeviceCategoryTabGroupComponent implements OnInit, OnDestroy {
	editSystem: boolean;
	editSystem$: Observable<boolean | undefined>;
	editSystemSub: Subscription;

	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;
	isImpersMode: boolean;

	currentSite: Site;
	site$: Observable<Site | undefined>;
	siteSub: Subscription | undefined;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	activeIndex: number;
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private route: ActivatedRoute,
		private translate: TranslateService,
		public dialogService: DialogService,
		private taskPollingService: TasksPollingService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onCurrentSiteChange();
		this.onResize();
	}

	initSelectors(): void {
		this.editSystem$ = this.store.select(selectEditSystem);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
		this.site$ = this.store.select(selectCurrentSite);
	}

	subscribeAll(): void {
		this.editSystemSub = this.editSystem$.subscribe(
			(editSystem) => {
				this.editSystem = editSystem;
			}
		);
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
	}

	ngOnDestroy(): void {
		this.editSystemSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
		this.siteSub?.unsubscribe();
	}

	onCurrentSiteChange(): void {
		this.siteSub = this.site$?.pipe(filter(currentSite => !!currentSite))
			.subscribe(currentSite => {
				this.currentSite = currentSite;
				// if (currentSite.Devices !== undefined && currentSite.Devices.length > 0) {
				// 	const deviceIds: number[] = currentSite.Devices.map(d => d.Id);
				// 	this.store.dispatch(DeviceActions.getDevicesStatus({ deviceIds }));
				// } else {
				// 	this.devicesStatus = [];
				// 	this.devices = [];
				// }
			}
		);
	}

	alertEmptySiteTimezone(): void {
		this.dialogService.open(CommonCustomConfirmDialogComponent, {
			header: this.translate.instant('TIMEZONE_SITE_NOT_SET'),
			contentStyle: { overflow: 'auto' },
			data: {
				icon: 'cm-alert',
				row1: 'TIMEZONE_SITE_NOT_SET_WARNING',
				visibleAcceptButton: false,
				labelRejectButton: 'CLOSE',
			}
		});
	}

	addGateway(): void {
		if (this.currentSite.Timezone === null || this.currentSite.Timezone === undefined || this.currentSite.Timezone === '') {
			this.alertEmptySiteTimezone();
		} else {
			this.ref = this.dialogService.open(AddGatewayDialogComponent, {
				header: this.translate.instant('ADD_DEVICE') + ' / ' + this.translate.instant('ADD_GATEWAY'),
				width: '70vw',
				breakpoints: { '1600px': '98vw' },
				contentStyle: { overflow: 'auto' },
				data: {
					site: this.currentSite
				}
			});
		}
	}

	selectedIndexChange(event): void {
		this.analyticsCustomPageView(event.index);
		this.store.dispatch(HomeActions.selectDeviceTab({ index: event.index }));
	}

	analyticsCustomPageView(index: number) {
		switch (index) {
			case 0:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'List Device | AUTOMATIONS' } }));
				}, 2000);
				break;
			case 1:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'List Device | TH' } }));
				}, 2000);
				break;
			case 2:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'List Device | VCT' } }));
				}, 2000);
				break;
			default:
				setTimeout(() => {
					this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'List Device | AUTOMATIONS' } }));
				}, 2000);
				break;
		}
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col6ResponsiveButtonLayout(position: string): string {
		return StandardPageLayout.col6ResponsiveButtonLayout(this.screenWidth, position);
	}
}
